import React, { useMemo } from 'react';
import type { SnippetRendererProps } from '@atlaskit/link-provider/types';

import { expVal } from '@atlassian/jira-feature-experiments';
// eslint-disable-next-line jira/restricted/fedramp-isolated-cloud
import { isFedRamp } from '@atlassian/atl-context';
import { AISnippet } from '@atlassian/ai-snippet/ai-snippet';

export const SyncJiraSnippetRenderer = (
	props: SnippetRendererProps,
): string | number | boolean | React.JSX.Element | Iterable<React.ReactNode> | null | undefined => {
	const runtimeProps = useMemo(
		() => ({
			contentId: props.contentId,
			contentType: props.contentType,
			cloudId: props.cloudId,
			fallbackText: props.fallbackText,
			fallbackComponent: props.fallbackComponent,
			isHidden: props.isHidden,
			maxLines: props.maxLines,
			showFooter: props.showFooter,
		}),
		[
			props.contentId,
			props.contentType,
			props.cloudId,
			props.fallbackText,
			props.fallbackComponent,
			props.isHidden,
			props.maxLines,
			props.showFooter,
		],
	);

	if (isFedRamp() || !expVal('jira-cc-ai-snippet-experiment', 'should_render_ai_snippet', false)) {
		return props.fallbackComponent;
	}

	return <AISnippet {...runtimeProps} />;
};

export default SyncJiraSnippetRenderer;
